import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { hasPrivilege, PLAYLIST_WRITE, getIsPlaylistEditable, hasMyTeamsAccess, canUserShare, getCanMembersContribute } from 'utils/privileges';
import Button from 'components/Button';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from 'screens/SinglePlaylistManager';
import SaveButton from './SaveButton';
import LikeButton from './LikeButton';
export default function Actions(_ref) {
  var playlist = _ref.playlist,
    toggleShareModal = _ref.toggleShareModal;
  var id = playlist.id,
    domain_id = playlist.domain_id;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var hasShareButton = canUserShare();
  var hasStatsButton = config.managerReports && hasMyTeamsAccess();
  var isDistributedPlaylist = +config.domain_id !== +domain_id;
  var hasAdminLink = isDistributedPlaylist && hasPrivilege(PLAYLIST_WRITE);
  var isPlaylistEditable = getIsPlaylistEditable({
    playlist: playlist,
    allowEditingDistributedPlaylists: true
  });
  var canUserEditPlaylist = isPlaylistEditable || getCanMembersContribute(playlist);

  // If the playlist details are not editable, but members can contribute
  // we send them straight to the content editor
  var editPlaylistRoute = isPlaylistEditable ? DEFAULT_EDIT_PLAYLIST_ROUTES.singlePlaylistDetails : DEFAULT_EDIT_PLAYLIST_ROUTES.singlePlaylistContent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SaveButton, {
    playlist: playlist
  }), /*#__PURE__*/React.createElement(LikeButton, {
    playlist: playlist
  }), hasShareButton && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "transparent",
    icon: "send",
    onClick: toggleShareModal
  }, t('actions_share')), hasStatsButton && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "transparent",
    as: Link,
    to: "/playlists/".concat(id, "/analytics/"),
    icon: "asset-diagram"
  }, t('analytics_team_progress')), canUserEditPlaylist && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "transparent",
    as: Link,
    to: generatePath(editPlaylistRoute, {
      playlistId: playlist.id
    }),
    icon: "edit"
  }, t('actions_edit_playlist')), hasAdminLink && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "transparent",
    as: "a",
    href: "/admin/playlists/".concat(id),
    target: "_blank",
    icon: "external"
  }, t('actions_view_in_dashboard')));
}